export const idx_data_axistilt = [];

idx_data_axistilt.push({
  tilt_measure: '',
  tilt_deg: '',
  tilt_group: '',
});

idx_data_axistilt.push({
  tilt_measure: '13.5',
  tilt_deg: '0',
  tilt_group: '1',
});

idx_data_axistilt.push({
  tilt_measure: '13',
  tilt_deg: '3',
  tilt_deg: '1',
});

idx_data_axistilt.push({
  tilt_measure: '12.5',
  tilt_deg: '7',
  tilt_deg: '2',
});

idx_data_axistilt.push({
  tilt_measure: '12',
  tilt_deg: '10',
  tilt_deg: '2',
});

idx_data_axistilt.push({
  tilt_measure: '11.5',
  tilt_deg: '13',
  tilt_deg: '3',
});

idx_data_axistilt.push({
  tilt_measure: '11',
  tilt_deg: '17',
  tilt_deg: '3',
});

idx_data_axistilt.push({
  tilt_measure: '10.5',
  tilt_deg: '20',
  tilt_deg: '3',
});

idx_data_axistilt.push({
  tilt_measure: '10',
  tilt_deg: '24',
  tilt_deg: '4',
});

idx_data_axistilt.push({
  tilt_measure: '9.5',
  tilt_deg: '27',
  tilt_deg: '4',
});

idx_data_axistilt.push({
  tilt_measure: '9',
  tilt_deg: '30',
  tilt_deg: '4',
});

idx_data_axistilt.push({
  tilt_measure: '8.5',
  tilt_deg: '33',
  tilt_deg: '5',
});

idx_data_axistilt.push({
  tilt_measure: '8',
  tilt_deg: '37',
  tilt_deg: '5',
});

idx_data_axistilt.push({
  tilt_measure: '7.5',
  tilt_deg: '40',
  tilt_deg: '5',
});
